/**
 * 通用工具函数
 */

const util = {
  getDefaultLang: () => {
    let defaultLang = window.navigator.language;
    // 做多语言标识符适配
    if (defaultLang && defaultLang.split('-')[0] === 'zh') {
      defaultLang = 'zh-CN';
    } else if (defaultLang && defaultLang.split('-')[0] === 'en') {
      defaultLang = 'en-US';
    } else {
      // 除了设置为中文系外，其它的默认都是英文
      defaultLang = 'en-US';
    }
    return defaultLang;
  },
  getParamFromUrl: (paramKey) => {
    const params = location.search.slice(1).split('&');
    const paramsObj = {};
    params.map((param) => {
      paramsObj[param.split('=')[0]] = param.split('=')[1];
    });
    return paramsObj[paramKey];
  },

  requestErrorHandle: (error) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
    console.log(error.config);
  },

  /**
   * 邮箱验证(当输入为空时要通过验证，非空验证逻辑要拆出来)
   * @param str
   * @returns {boolean}
   */
  isEmail(str) {
    if (typeof str !== 'string') {
        return false;
    }
    let reg = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return reg.test(str.trim());
  },

  /**
   * 电话验证，这里只做是不是11为数字的验证(当输入为空时要通过验证，非空验证逻辑要拆出来)
   * @param tel
   * @returns {boolean}
   */
  isTel(tel) {
    if (typeof tel === 'undefined') {
        return false;
    }
    if (typeof tel === 'string') {
        tel = tel.trim();
    }
    let reg = /^\d{11}$/;
    return reg.test(tel);
  },
  /**
   * 取cookie
   * @param {string} cname
   */
  getCookie (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) 
    {
      var c = ca[i].trim();
      if (c.indexOf(name)==0) return c.substring(name.length,c.length);
    }
    return "";
  }
};

export default util;


// WEBPACK FOOTER //
// ./src/utils.js